import TextField from '@guestyci/foundation/TextField';
import Layout from 'app/shareable/layouts/Layout';
import useCustomTextFieldStyles from 'app/shareable/theme/useCustomTextFieldStyles';

export default function ErrorPage() {
  const classes = useCustomTextFieldStyles();

  return (
    <Layout captureText="One Tool. Better Way To Manage.">
      <div>
        <TextField className={classes.h1}>Error</TextField>
        <div className="mt-2">
          <TextField className={classes.h3}>
            We apologize, but the link is no longer valid.
          </TextField>
        </div>
      </div>
    </Layout>
  );
}
